/**
 * AuthGate — forced-password gate (AL-M3, ST9 / F2).
 *
 * Renders INSIDE <BrowserRouter> (wraps <Routes>) so HubLayout and the setup
 * form keep router context (DESIGN §4.3, F-crit-1). When a signed-in user has
 * no password (`hasPassword === false` — a federated-only user), it short-
 * circuits before any route renders and shows the mandatory setup screen, so
 * the user cannot reach the dashboard or deep-link past it.
 *
 * While signed out (e.g. mid-link-flow on /auth/link-confirm) the gate is
 * transparent.
 */

import React from "react";
import {
  ForcedPasswordSetup,
  useAuth,
} from "@d-m-organization/hub-shared-lib/auth";
import { HubLayout } from "../components/HubLayout.js";
import { PageLoadingShell } from "../components/PageLoadingShell.js";

const API_BASE = import.meta.env.VITE_API_BASE_URL as string;

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { isAuthReady, isAuthed, user } = useAuth();

  if (!isAuthReady) return <PageLoadingShell />;
  if (!isAuthed || !user) return <>{children}</>;
  if (user.hasPassword === false) {
    return <ForcedPasswordSetup apiBase={API_BASE} wrapper={HubLayout} ns="common" />;
  }
  return <>{children}</>;
}
